import React, { createContext } from "react";

const Context = createContext(0);

export default Context;
